import React, { useEffect, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import paginationFactory, {
    PaginationProvider,
} from 'react-bootstrap-table2-paginator'
import './datatable.scss'
import { ButtonGroup } from 'react-bootstrap'
import { Icons } from '../../assets/icons/icons'
import CustomCheckbox from './CustomCheckbox'
import { useTranslation } from 'react-i18next'
import Buttons from '../DataEntryComponents/Button/Buttons'
import { AcNoDataView } from '../../components/UiComponents/AcImports'
import { planogramTypeList, showList } from '../../enums/planogramTypes'

const DataTable = (props) => {
    const {
        isRTL,
        columns,
        data,
        onButtonClick,
        onSelect,
        selectedRows,
        dmode,
        total,
        handlePagination,
        startIndex,
        setPage,
        page,
        filters,
        setSelectedRows,
        handleTableChange,
        showListProp,
        listKey,
        isOnClickEnable = false,
        onClickCallbackFunc,
    } = props
    const { t } = useTranslation()
    const [totalPages, setTotalPages] = useState(0)
    const [paginationOption, setPaginationOption] = useState({})
    const [ptotalresults, setPtotalresults] = useState(0)
    const [pstartcount, setPstartcount] = useState(1)
    const [pendcount, setPendCount] = useState(0)
    const [hoveredRow, setHoveredRow] = useState(null)

    //row selection in list
    const selectRow = {
        mode: 'radio',
        clickToSelect: false,
        style: {
            backgroundColor: hoveredRow ? '#FFF6E5' : '',
            color: '#000',
        },
        classes: 'selection-row',
        selected: selectedRows,
        // selectionRenderer: (props) => <CustomCheckbox {...props} />,
        selectionRenderer: (props) => null,
        onSelect: (row, isSelect, rowIndex, e) =>
            onSelect(row, isSelect, rowIndex, e),
    }

    useEffect(() => {
        setPaginationOption({
            sizePerPage: filters?.maxResult,
            showTotal: true,
            hideSizePerPage: true,
            custom: true,
            totalSize: total,
        })
    }, [page, filters])

    //next,prve,first,last page moving here
    const handleNextPage =
        ({}) =>
        () => {          
            if (page < totalPages) {
                const newPage = page + 1
                setPage(newPage)
            
                handlePagination(newPage)
                setSelectedRows([]) //when paginate, clear the select row
            }
        }

    const handlePrevPage =
        ({}) =>
        () => {
            if (page > 1) {
                const newPage = page - 1
                setPage(newPage)
                handlePagination(newPage)
                setSelectedRows([]) //when paginate, clear the select row
            }
        }

    const handleFirstpage =
        ({}) =>
        () => {
            if (page > 1) {
                handlePagination(1)
                setPage(1)
                setSelectedRows([]) //when paginate, clear the select row
            }
        }

    const handleLastPage =
        ({}) =>
        () => {
            if (page < totalPages) {
                handlePagination(totalPages)
                setPage(totalPages)
                setSelectedRows([]) //when paginate, clear the select row
            }
        }

    useEffect(() => {
        //const cpcount = (data?.length ? data?.length : filters?.maxResult)
        const perPageCount = filters?.maxResult
        const totalResultCount = total ? total : 0
        const startIndex = page > 1 ? perPageCount * (page - 1) + 1 : 1
        const pendcount =
            totalResultCount > perPageCount * page
                ? perPageCount * page
                : totalResultCount
        const pageCount = Math.ceil(total / filters?.maxResult)
        setPstartcount(startIndex) //set start index of selected page
        setPendCount(pendcount) //set end index of selected page
        setPtotalresults(totalResultCount) // set total result count
        setTotalPages(pageCount) // set page count
    }, [data, total, page, filters])

    const rowEvents = {
        onMouseEnter: (e, row) => {
            setHoveredRow(row[listKey])
            setSelectedRows([row.id]), onSelect(row, true, null, null)
        },
        onMouseLeave: (e, row) => {
            setHoveredRow(null)
            setSelectedRows([]), onSelect(row, false, null, null)
        },
        onClick: (e, row, rowIndex) => {
            if (isOnClickEnable) {
                onClickCallbackFunc(row, rowIndex)
            }
        },
    }

    return (
        <>
            {data?.length > 0 ? (
                <>
                    <PaginationProvider
                        pagination={paginationFactory(paginationOption)}
                    >
                        {({ paginationProps, paginationTableProps }) => (
                            <div>
                                <div className="table-scroll-container">
                                <BootstrapTable
                                    remote
                                    onTableChange={handleTableChange}
                                    classes={`v2-table ${
                                        dmode ? 'v2-table-dark' : ''
                                    } table-hover`}
                                    keyField={listKey}
                                    // key={listKey}
                                    data={data}
                                    columns={columns}
                                    bordered={true}
                                    pagination={paginationFactory(
                                        paginationOption
                                    )}
                                    selectRow={selectRow}
                                    rowEvents={rowEvents}
                                    // rowStyle={rowStyle}
                                    headerClasses={`v2-header-class ${
                                        dmode ? 'v2-header-class-dark' : ''
                                    }`}
                                    rowClasses={`v2-body-class ${
                                        dmode ? 'v2-body-class-dark' : ''
                                    }`}
                                    //defaultSorted={showListProp == showList.PLANOGRAM_LIST ? defaultSortedPlanogram : defaultSortedSimulation}
                                    hover
                                    {...paginationTableProps} // Capture sort event
                                    //noDataIndication={() => {total > 0 ? t('DATA_LOADING'):''}}
                                />
                                </div>

                                <label className="paginate-text">
                                    <label
                                        className={`paginate-text-inner ${
                                            dmode
                                                ? 'paginate-text-inner-dark'
                                                : ''
                                        }`}
                                    >
                                        {t('showing')} {pstartcount} {t('to')}{' '}
                                        {pendcount} {t('of')} {ptotalresults}{' '}
                                        {t('results')}
                                    </label>
                                </label>

                                <div
                                    className={
                                        'btn-group paginate-button-group ' +
                                        (isRTL === 'rtl'
                                            ? 'paginate-button-group-rtl'
                                            : '')
                                    }
                                    role="group"
                                    dir="ltr"
                                >
                                    <ButtonGroup aria-label="pagination-button-group">
                                        <Buttons
                                            className="v2-paginate-buttons"
                                            size="sm"
                                            clickEvent={
                                                isRTL === 'rtl'
                                                    ? handleLastPage(paginationProps)
                                                    : handleFirstpage(paginationProps)
                                            }
                                            btnIcon={Icons.ChevronDoubleLeft()}
                                            variant="outline-secondary"
                                            dir={isRTL}
                                            isDisbled={
                                                isRTL === 'ltr'
                                                    ? page === 1
                                                        ? true
                                                        : false
                                                    : page < totalPages
                                                    ? false
                                                    : true
                                            }
                                        />
                                        <Buttons
                                            className={`v2-paginate-buttons paginate-btn-first-back ${
                                                dmode
                                                    ? 'v2-paginate-btn-first-back-dark'
                                                    : ''
                                            }`}
                                            size="sm"
                                            clickEvent={
                                                isRTL === 'rtl'
                                                    ? handleNextPage(
                                                          paginationProps
                                                      )
                                                    : handlePrevPage(
                                                          paginationProps
                                                      )
                                            }
                                            btnIcon={Icons.ChevronLeft()}
                                            variant="outline-secondary"
                                            dir={isRTL}
                                            isDisbled={
                                                isRTL === 'ltr'
                                                    ? page === 1
                                                        ? true
                                                        : false
                                                    : page < totalPages
                                                    ? false
                                                    : true
                                            }
                                        />
                                        <input
                                            type="text"
                                            width={10}
                                            value={
                                                isRTL === 'rtl'
                                                    ? (totalPages
                                                          ? totalPages
                                                          : 0) +
                                                      '/' +
                                                      page
                                                    : page +
                                                      '/' +
                                                      (totalPages
                                                          ? totalPages
                                                          : 0)
                                            }
                                            className={`paginate-display-input ${
                                                dmode
                                                    ? 'v2-paginate-display-input'
                                                    : ''
                                            }`}
                                            size="sm"
                                            readOnly
                                        ></input>
                                        <Buttons
                                            className={`v2-paginate-buttons paginate-btn-first-next ${
                                                dmode
                                                    ? 'v2-paginate-btn-first-next-dark'
                                                    : ''
                                            }`}
                                            size="sm"
                                            clickEvent={
                                                isRTL === 'rtl'
                                                    ? handlePrevPage(
                                                          paginationProps
                                                      )
                                                    : handleNextPage(
                                                          paginationProps
                                                      )
                                            }
                                            btnIcon={Icons.ChevronRight()}
                                            variant="outline-secondary"
                                            dir={isRTL}
                                            isDisbled={
                                                isRTL === 'ltr'
                                                    ? page === totalPages
                                                        ? true
                                                        : false
                                                    : page > 1
                                                    ? false
                                                    : true
                                            }
                                        />
                                        <Buttons
                                            className="v2-paginate-buttons paginate-btn-next-end"
                                            size="sm"
                                            clickEvent={
                                                isRTL === 'rtl'
                                                    ? handleFirstpage(
                                                          paginationProps
                                                      )
                                                    : handleLastPage(
                                                          paginationProps
                                                      )
                                            }
                                            btnIcon={Icons.ChevronDoubleRight()}
                                            variant="outline-secondary"
                                            dir={isRTL}
                                            isDisbled={
                                                isRTL === 'ltr'
                                                    ? page === totalPages
                                                        ? true
                                                        : false
                                                    : page > 1
                                                    ? false
                                                    : true
                                            }
                                        />
                                    </ButtonGroup>
                                </div>
                            </div>
                        )}
                    </PaginationProvider>
                </>
            ) : (
                <div className="no-data">
                    <AcNoDataView />
                </div>
            )}
        </>
    )
}
export default DataTable
